module.exports = __webpack_public_path__ + "img/icon-bullet-close.7e8e40b6.svg";